export default __webpack_public_path__ + "static/media/result-bad.a3b2213f.png";